<script>
    import ui_Ico from './ui-Ico.vue';

    export default {
        extends: ui_Ico,
        template: ui_Ico.template,
        name: 'ui-IcoBtn',
        props: {
            active: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            this.$el.addEventListener('click', this.changeStatus);
        },
        methods: {
            getClass: function() {
                var classStyles = `ico--button ${ui_Ico.methods.getClass.call(this)}`;

                if (this.active) classStyles = `${classStyles} ico--active`;

                return classStyles;
            },
            changeStatus: function(event) {
                if (!this.disabled) {
                    event.stopPropagation();
                    this.$emit('click');
                }
            },
        },
    };
</script>
